var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('client-form',{attrs:{"loading":_vm.loading,"clientData":_vm.client,"formErrors":_vm.formErrors},on:{"clientSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }